$(function () {

  $('.js-faq-link').on('click', function (e) {
    e.preventDefault();
    const $target = $(this)
    const $container = $target.parents('.js-faq')
    const $content = $container.find('.js-faq-content')
    const $links = $container.find('.js-faq-link')
    const $targetContent = $target.next('.js-faq-content')

    if ( $target.hasClass('active') ) {
      $target.removeClass('active')
      $targetContent.slideUp(300)
    } else {
      $links.removeClass('active')
      $content.slideUp(300)
      $target.addClass('active')
      $targetContent.slideDown(300)
    }
  })

})